import type { InjectionToken } from 'tsyringe';
import type { ParamMap } from 'urlcat';

export type HttpRequestOptions<Type = unknown> = Pick<
  RequestInit,
  'headers' | 'signal' | 'body' | 'method'
> & {
  onError?: (error: unknown, url: string, config: HttpRequestOptions<Type>) => Promise<Type>;
  onResponse?: (response: Response) => Promise<Type>;
  params?: ParamMap;
};

export interface IHttpClient {
  delete<Type>(url: string, options?: HttpRequestOptions<Type>): Promise<Type>;
  get<Type>(url: string, options?: HttpRequestOptions<Type>): Promise<Type>;
  patch<Type>(url: string, data?: object, options?: HttpRequestOptions<Type>): Promise<Type>;
  post<Type>(url: string, data?: object, options?: HttpRequestOptions<Type>): Promise<Type>;
  put<Type>(url: string, data?: object, options?: HttpRequestOptions<Type>): Promise<Type>;
}

export const HTTP_CLIENT: InjectionToken<IHttpClient> = 'HttpClient';
